import React from 'react';
import ToggleSwitch from './ToggleSwitch'


class General extends React.Component {
	constructor() {
		super()
		this.state = {
			togglePomodoro: true,
			toggleWeather: true,
			toggleQuotes: true,
			toggleTodo: true,
			toggleSeconds: true,
			toggleDate: true,
			toggle12hr: false,
			toggle24hr: true,
			blueRed: true,
			navyWine: false,
			toggleTime: true,
		}

		this.handlePomodoro = this.handlePomodoro.bind(this);
		this.handleWeather = this.handleWeather.bind(this);
		this.handleQuotes = this.handleQuotes.bind(this);
		this.handleTodo = this.handleTodo.bind(this);
		this.handle24hrOption = this.handle24hrOption.bind(this);
		this.handle12hrOption = this.handle12hrOption.bind(this);
		this.handleSeconds = this.handleSeconds.bind(this);
		this.handleDate = this.handleDate.bind(this);
		this.handleThemeSelection = this.handleThemeSelection.bind(this);
		this.handleTime = this.handleTime.bind(this);
	}

	//this function will handle all DOM adjustments for the toggleSwitch
	//this function is a constructor function used by all handle functions
	handleDOM(iconDOMName, settingsToggleDOMName, stateName) {
		if (stateName === false){
			document.querySelector(iconDOMName).classList.add('fade-out')
			document.querySelector(settingsToggleDOMName).classList.remove('checked')
			setTimeout(() => {
				document.querySelector(iconDOMName).classList.add('hide')
			}, 500)
		} else {
			document.querySelector(iconDOMName).classList.remove('hide')
			document.querySelector(settingsToggleDOMName).classList.add('checked')
			setTimeout(() => {
				document.querySelector(iconDOMName).classList.remove('fade-out')
			}, 10)
		}
	}

	async handlePomodoro() {
		await this.setState((prevState) => ({togglePomodoro: !prevState.togglePomodoro}))
		return this.handleDOM('.box-three','.toggle-pomodoro input', this.state.togglePomodoro );
	}

	async handleWeather() {
		await this.setState((prevState) => ({toggleWeather: !prevState.toggleWeather}))
		this.handleDOM('.weather-list-container', '.toggle-weather input', this.state.toggleWeather)
	}

	async handleQuotes() {
		await this.setState((prevState) => ({toggleQuotes: !prevState.toggleQuotes}))
		this.handleDOM('.quotes-container', '.toggle-quotes input', this.state.toggleQuotes)
	}

	async handleTodo() {
		await this.setState((prevState) => ({toggleTodo: !prevState.toggleTodo}))
		return this.handleDOM('.todo-label', '.toggle-todo input', this.state.toggleTodo)
	}

	async handle24hrOption() {
		await this.setState({
			toggle12hr: false,
			toggle24hr: true
		})
		this.toggle12or24hrClock();
	}

	toggle12or24hrClock() {
		if (this.state.toggle12hr === false) {
			document.querySelector('.hr24').classList.add('active')
			document.querySelector('.hr12').classList.remove('active')
			document.querySelector('.time-hours-12').classList.remove('show')
			document.querySelector('.time-hours').classList.add('show')
		} else {
			document.querySelector('.hr12').classList.add('active');
			document.querySelector('.hr24').classList.remove('active');
			document.querySelector('.time-hours-12').classList.add('show')
			document.querySelector('.time-hours').classList.remove('show')
		}
	}

	async handle12hrOption() {
		await this.setState({
			toggle12hr: true,
			toggle24hr: false
		})
		this.toggle12or24hrClock();	
	}

	async handleThemeSelection(e) {
		if (e.target.id === 'blueRed') {
			this.setState({
				blueRed: true,
				navyBlue: false
			})
			document.querySelector('.red').style.background = '#8F4A4F';
			document.querySelectorAll('.blue').forEach(item => item.style.background = '#3C728F');
			document.querySelector('.blue-red').classList.add('active')
			document.querySelector('.navy-wine').classList.remove('active')
		} else {
			this.setState({
				blueRed: false,
				navyBlue: true
			})
			document.querySelector('.red').style.setProperty('background', '#153342');
			document.querySelectorAll('.blue').forEach(item => item.style.setProperty('background', '#421C20'));
			document.querySelector('.blue-red').classList.remove('active')
			document.querySelector('.navy-wine').classList.add('active')
		}
	}

	async handleTime() {
		await this.setState((prevState) => ({toggleTime: !prevState.toggleTime}))
		this.handleDOM('.time-container', '.toggle-time input', this.state.toggleTime)
	}

	async handleSeconds() {
		await this.setState((prevState) => ({toggleSeconds: !prevState.toggleSeconds}))
		return this.handleDOM('.time-seconds', '.toggle-seconds input', this.state.toggleSeconds)
	}

	async handleDate() {
		await this.setState((prevState) => ({toggleDate: !prevState.toggleDate}))
		return this.handleDOM('.box-one', '.toggle-date input', this.state.toggleDate )
	}

	// fetch data from backend server
	// async componentDidMount() {
	// 	const url = 'http://localhost:4000/general';

	// 	const response = await (fetch(url))
	// 	const json = await response.json()
	// 	console.log(json)
	// 	this.setState({
	// 		togglePomodoro: json[0].pomodoro,
	// 		toggleWeather: json[0].weather,
	// 		toggleQuotes: json[0].quotes,
	// 		toggleTodo: json[0].todo,
	// 		toggleSeconds: json[0].seconds,
	// 		toggleDate: json[0].date,
	// 		toggle12hr: json[0].toggle12hr,
	// 		toggle24hr: json[0].toggle24hr
	// 	})
				
	// 	this.handleDOM('.pomo-label','.toggle-pomodoro input', this.state.togglePomodoro );
	// 	this.handleDOM('.weather-list-container', '.toggle-weather input', this.state.toggleWeather)
	// 	this.handleDOM('.quotes-container', '.toggle-quotes input', this.state.toggleQuotes)
	// 	this.handleDOM('.todo-label', '.toggle-todo input', this.state.toggleTodo)
	// 	this.handleDOM('.seconds', '.toggle-seconds input', this.state.toggleSeconds)
	// 	this.handleDOM('.date', '.toggle-date input', this.state.toggleDate )
	// 	this.toggle12or24hrClock();
	// }

	//send API request to update changes
	// componentDidUpdate() {
	// 	const url = 'http://localhost:4000/general';
	// 	let body = {
	// 		pomodoro: this.state.togglePomodoro,
	// 		weather: this.state.toggleWeather,
	// 		quotes: this.state.toggleQuotes,
	// 		todo: this.state.toggleTodo,
	// 		seconds: this.state.toggleSeconds,
	// 		date: this.state.toggleDate,
	// 		toggle12hr: this.state.toggle12hr,
	// 		toggle24hr: this.state.toggle24hr
	// 	}
	// 	const options = {
	// 		method: 'PUT',
	// 		body: JSON.stringify(body),
	// 		headers: {
	// 			"Content-Type": "application/json"
	// 		}
	// 	}
	// 	fetch(url, options)
	// }
	render() {
		return(
		<div className='general-settings right-side-body'>
			<div className='options-heading'>
				<h1>General</h1>
				<p>Customize your dashboard</p>
			</div>
			<div className='general-display'>
				<h4 className='settings-sub-heading'>Display</h4>
				<div className='selected-options-item theme-format'>
					<span>Theme Format</span>
					<div className='toggle-options' onClick={this.handleThemeSelection}>
						<span id='blueRed' className='blue-red active'>Blue/Red</span>
						<span> | </span>
						<span id='navyWine' className='navy-wine'>Navy/Wine</span>
					</div>
				</div>
			</div>
			<div className='general-time'>
				<h4 className='settings-sub-heading'>Time Options</h4>
				<div className='selected-options-item clock-format'>
					<span>Clock Format</span>
					<div className='toggle-options'>
						<span className='hr12 active' onClick={this.handle12hrOption}>12 Hour</span>
						<span> | </span>
						<span className='hr24' onClick={this.handle24hrOption}>24 Hour</span>
					</div>
				</div>
				<ToggleSwitch className='toggle-seconds' title='Show Seconds' handlerFunction={this.handleSeconds} />
				<ToggleSwitch className='toggle-date' title='Show Date' handlerFunction={this.handleDate} />
				<ToggleSwitch className='toggle-time' title='Show Time' handlerFunction={this.handleTime} />
			</div>
		</div>
		)
	}
	
}

export default General